import { createMuiTheme } from "@material-ui/core/styles";

export const themeTabel = createMuiTheme({
  palette: {
    primary: {
      main: "#ed563b",
      light: "#ed563b",
      padding: "0",
    },
    secondary: {
      main: "#0",
      light: "#ed563b",
      padding: "0",
    },
    success: {
      main: "#fff",
      light: "#fff",
      padding: "0",
    },
  },

  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
});
